interface Props {
  borderColor: string;
  description2Color?: string;
  title: string;
  description?: string;
  value: string | number;
  description2?: string;
  icon?: string;
  isFirst?: boolean;
}
const CardCountPerformance = ({
  borderColor,
  title,
  description,
  value,
  description2,
  icon,
  isFirst,
  description2Color,
}: Props) => {
  return (
    <div className="bg-white shadow-smooth width-100pct shadow-default display-flex padding-y-25">
      <div className={`width-10 ${borderColor}`} />

      <div className="padding-x-15 display-flex width-100pct">
        <div className="width-100pct display-flex flex-column justify-content-between">
          <div className="display-flex width-100pct flex-column">
            <span className="text-size-16 text-bold">{title}</span>
            <span className={`text-size-16 text-normal text-color-gray ${isFirst ? "text-decoration-none" : "text-decoration-line-through"}`}>{description}</span>
          </div>
          <div className="display-flex width-100pct">
            <span className="text-size-h3 text-color-primary text-bold">{value}</span>
          </div>
          <div className="display-flex width-100pct">
            <span className={`text-size-16 text-normal ${description2Color}`}>{description2}</span>
          </div>
        </div>
        <div>
          <span className={`${icon} text-color-primary text-size-h1`}></span>
        </div>
      </div>
    </div>
  );
};

export default CardCountPerformance;
